import { mockMedia } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">漫画视频</h2>
          <p className="text-sm text-foreground-600 max-w-[500px] mx-auto">
            漫画推荐与入坑指南，精彩漫画内容一睹为快
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
          {mockMedia.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden cursor-pointer hover:border-primary-200 transition-all duration-300"
            >
              <div className="relative w-full aspect-[8/5] overflow-hidden">
                <img
                  src={item.image}
                  alt={`虫虫漫画视频 - ${item.title}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-foreground-950/20 group-hover:bg-foreground-950/10 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-foreground-950/70 text-background-50 text-xs rounded">
                  {item.duration}
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-medium text-foreground-800 mb-1 line-clamp-1">{item.title}</h3>
                <p className="text-xs text-foreground-500">{item.subtitle}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}